import styled from 'styled-components';
export { ArrowLeftIcon, LinkButton, WarehouseIcon } from 'styles/components';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
